import React from 'react';

import { useTranslation } from 'react-i18next';
import GameIcon from '../../assets/images/gameOfMonth.png'
import { NavLink } from 'react-router-dom';


export default React.memo(function GameOfMonthBlocks({
                                                       children, slideWidth = 260, speed = 10,
                                                       className = '', containerClassName = '',
                                                       direction = 'left'
                                                     }) {
  const { t } = useTranslation('common');

  return <div className={'grid grid-cols-1 md:grid-cols-2  bg-brandedColor rounded-xl '}>
    <div className={'relative flex w-full h-[225px] items-center justify-center '}>
      <div
        className={'absolute  w-[265px] h-[265px] md:w-[340px] md:h-[360px]lg:w-[360px] lg:h-[360px] 2xl:w-[368px] 2xl:h-[368px] -top-10 left-1/2 transform -translate-x-1/2 rotate-[0.14rad] '}>
        <div className={'rounded-xl overflow-hidden shadow-lg shadow-[0_22.65px_45.29px_-11.32px_rgba(_0,_0,_0,_0.5)]'}>
          <img src={GameIcon} alt={`${t('labels.game_of_Month')}`} />
        </div>
      </div>
    </div>
    <div className={' w-full text-white p-[60px] md:pl-0'}>
      <div className="pb-8">
      <span className={'text-[56px] leading-10 font-medium text-white'}>
      {t('labels.game_of_Month')}
      </span></div>
      <div
        className="text-xl font-normal leading-[1.5]">{t('descriptions.game_of_month')}</div>

      <div className={'flex flex-col md:flex-row gap-4 mt-10 text-center'}>
        <NavLink to={'/games'} className={'block text-white'}>
                  <span
                    className={'block py-[10px] px-[15px] bg-white text-base overflow-hidden rounded-lg '}>
                    <span className={'relative text-black z-[1] select-none'}>
                      {t('buttons.play_demo')}
                    </span>
                  </span>
        </NavLink>
        <NavLink to={'/games'} className={''}>
                  <span
                    className={'block py-[10px] px-[15px] text-white text-base  overflow-hidden border border-white rounded-lg whitespace-nowrap'}>
                    <span className={'relative z-[1]'}>
                      {t('buttons.game_info')}
                    </span>
                  </span>
        </NavLink>
      </div>
    </div>


  </div>
})

